import axios from "axios";
import { IP } from "../index.js";
/* 病种管理 */
export async function selectCategory() {
  var resp = await axios.post(`${IP}/admin/diseaseCategory/select`, {});
  return resp.data;
}

export async function addCategory(data) {
  var resp = await axios.post(`${IP}/admin/diseaseCategory/add`, {
    ...data,
  });
  return resp.data;
}

export async function updateCategory(data) {
  var resp = await axios.post(`${IP}/admin/diseaseCategory/update`, {
    ...data,
  });
  return resp.data;
}

export async function deleteCategory(id) {
  var resp = await axios.post(`${IP}/admin/diseaseCategory/delete`, { id });
  return resp.data;
}

